import ClickOutAlertWrapper from "../../wrappers/ClickOutAlertWrapper/ClickOutAlertWrapper";
import { ReactElement, useRef, useState } from "react";

import "./NumberInputToggleField_style.css";
import FlexRow from "../../layout/Flexbox/FlexRow";

type Props = {
    className?: string;
    label?: string | null | undefined;
    displayFieldStyle?: React.CSSProperties | undefined;
    editorFieldStyle?: React.CSSProperties | undefined;
    isEditable?: boolean;
    value: number;
    formatValueTextField?: (val: number) => string;
    onStopEditing?: (val: number) => void;
    onEnterKeyPress?: () => void;
    onLabelClick?: () => void;
};

export default function NumberInputToggleField({className, label, displayFieldStyle, editorFieldStyle, isEditable = true, value, formatValueTextField, onStopEditing, onEnterKeyPress, onLabelClick}: Props): ReactElement {
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [pendingValue, setPendingValue] = useState<number>(value);

    const ref = useRef(null);
    const valueRef = useRef<number>(value);

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            onEnterKeyPress?.();
        }
    };

    return (
        <div
            ref={ref}
            className={`number-input-field-container${
                className ? ` ${className}` : ``
            }`}
        >
            <FlexRow>
                {label != null && (
                    <div className={`label-field${onLabelClick == null ? '' : ' clickable'}`} onClick={onLabelClick}>{label}</div>
                )}
                {isEditing ? (
                    <ClickOutAlertWrapper
                        forwardRef={ref}
                        onClickOut={() => {
                            setIsEditing(false);
                            onStopEditing?.(valueRef.current);
                        }}
                    >
                        <input
                            type="number"
                            className={`editor-field`}
                            style={editorFieldStyle}
                            value={pendingValue}
                            autoFocus={true}
                            onKeyDown={(event) => {
                                handleKeyDown(event);
                            }}
                            onChange={(e) => {
                                setPendingValue(() => {
                                    const val = Number.parseInt(e.target.value);
                                    valueRef.current = val;
                                    return val;
                                });
                            }}
                            onBlur={() => {
                                setIsEditing(false);
                                onStopEditing?.(valueRef.current);
                            }}
                        />
                    </ClickOutAlertWrapper>
                ) : (
                    <div
                        className={`display-field${
                            isEditable ? " editable" : ""
                        }`}
                        style={displayFieldStyle}
                        onClick={() => {
                            if (isEditable) {
                                setIsEditing(true);
                            }
                        }}
                    >
                        {formatValueTextField == null
                            ? value.toString()
                            : formatValueTextField(value)}
                    </div>
                )}
            </FlexRow>
        </div>
    );
}
